/* eslint-disable react/prop-types */
import React, { useContext } from "react";

import { DocumentContext } from "~context/DocumentContext";

import { splitStringToParagraphs } from "~utils/helpers";

const Text = ({ section, bannerFont }) => {
  const { device } = useContext(DocumentContext);

  const colorClasses = `bg-${section.backgroundColor} border-t-${section.borderTop} text-${section.fontColor}`;

  return (
    <section
      className={`text-section w-full relative block pt-v7 xs:pt-v14 pb-v14 xs:pb-28 ${colorClasses}`}
    >
      <div className="grid">
        {section?.heading && (
          <h3
            className={`grid-end-12 mb-v6 xs:mb-v10 ${
              device === `mobile` ? `f3` : `f2`
            } ${bannerFont}`}
          >
            {splitStringToParagraphs(section.heading, `whitespace-pre-wrap`)}
          </h3>
        )}
      </div>

      <div className="grid">
        <div className="grid-end-6 xs:grid-end-8 whitespace-pre-wrap">
          {section?.contentLeftHeading && (
            <h4 className="mb-v1 xs:mb-v2 universal-sans b2">
              {section.contentLeftHeading}
            </h4>
          )}
          <p className="mb-v3 b1 universal-sans">{section.contentLeft}</p>
        </div>

        <div className="grid-end-6 xs:grid-end-8 xs:mt-v0 whitespace-pre-wrap">
          {section?.contentRightHeading && (
            <h4 className="mb-v1 xs:mb-v2 universal-sans b2">
              {section.contentRightHeading}
            </h4>
          )}
          <p className="mb-v3 b1 universal-sans">{section.contentRight}</p>
        </div>
      </div>
    </section>
  );
};

export default Text;
